export const GET_STARTED_SCHEDULING_URL =
  'https://meetings.hubspot.com/michael-koziol';
